import { useState } from 'react'
import { supabase } from '@/lib/supabase'

export function useSchedules(userId) {
  const [savedSchedule, setSavedSchedule] = useState(null)

  function loadScheduleFromData(data) {
    if (data) {
      setSavedSchedule({
        id: data.id,
        scheduleDate: data.schedule_date,
        dayStart: data.day_start,
        dayEnd: data.day_end,
        schedule: data.schedule,
      })
    } else {
      setSavedSchedule(null)
    }
  }

  async function saveSchedule(scheduleDate, dayStart, dayEnd, scheduleItems, activeTermId) {
    const row = {
      user_id: userId,
      term_id: activeTermId,
      schedule_date: scheduleDate,
      day_start: dayStart,
      day_end: dayEnd,
      schedule: scheduleItems,
    }
    const { data, error } = await supabase
      .from('daily_schedules')
      .upsert(row, { onConflict: 'user_id,schedule_date' })
      .select()
      .single()

    if (!error && data) {
      setSavedSchedule({
        id: data.id,
        scheduleDate: data.schedule_date,
        dayStart: data.day_start,
        dayEnd: data.day_end,
        schedule: data.schedule,
      })
    }
    return { error }
  }

  async function loadScheduleByDate(dateStr) {
    const { data, error } = await supabase
      .from('daily_schedules')
      .select('*')
      .eq('user_id', userId)
      .eq('schedule_date', dateStr)
      .single()
    if (error || !data) return null
    return {
      id: data.id,
      scheduleDate: data.schedule_date,
      dayStart: data.day_start,
      dayEnd: data.day_end,
      schedule: data.schedule,
    }
  }

  async function listScheduleDates() {
    const { data } = await supabase
      .from('daily_schedules')
      .select('schedule_date')
      .eq('user_id', userId)
      .order('schedule_date', { ascending: false })
    return (data || []).map(r => r.schedule_date)
  }

  return {
    savedSchedule,
    loadScheduleFromData,
    saveSchedule,
    loadScheduleByDate,
    listScheduleDates,
  }
}
